import { Group } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import { Modal } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';

export default function ToReceiveColumnTitle() {
  const toReceiveInfo = () =>
    Modal.confirm({
      title: 'Valor a receber',
      content:
        'O valor a receber é um informativo de previsão de quanto a Porto pagará a oficina pelo serviço prestado ao segurado',
      okButtonProps: { style: { display: 'none' } },
      cancelText: 'Fechar',
    });

  return (
    <Group gap={4}>
      <span>A receber</span>
      <ActionIcon onClick={toReceiveInfo}>
        <FaInfoCircle size={14} />
      </ActionIcon>
    </Group>
  );
}
